export default "__VITE_ASSET__Du8Qc5N0__"